import enviro from 'enviro';
import Products from 'merchandise-lib/constants/Product';
export const TrialIds = {
  SALES_ENTERPRISE: 1,
  MARKETING_ENTERPRISE: 2,
  SERVICE_ENTERPRISE: 3,
  MARKETING_PRO: 4,
  CMS_PROFESSIONAL: 7,
  SALES_PROFESSIONAL: 8,
  SERVICE_PROFESSIONAL: 9,
  CMS_ENTERPRISE: enviro.isProd() ? 18 : 17,
  // Legacy Operations Hub Trial IDs
  OPERATIONS_PROFESSIONAL: enviro.isProd() ? 35096 : 43098,
  OPERATIONS_ENTERPRISE: enviro.isProd() ? 52399 : 70192,
  DATA_PROFESSIONAL: enviro.isProd() ? 247334 : 349115,
  DATA_ENTERPRISE: enviro.isProd() ? 247335 : 349116,
  MARKETING_PLUS_PROFESSIONAL_BUNDLE: enviro.isProd() ? 200098 : 270355,
  MARKETING_PLUS_ENTERPRISE_BUNDLE: enviro.isProd() ? 200097 : 270725,
  CRM_SUITE_STARTER_BUNDLE: enviro.isProd() ? 222377 : 318128,
  COMMERCE_PROFESSIONAL: enviro.isProd() ? 241458 : 349410,
  COMMERCE_ENTERPRISE: enviro.isProd() ? 241459 : 349411,
  CORE_SEATS_ENTERPRISE_HSOC: enviro.isProd() ? 282196 : 380336,
  CORE_SEATS_ENTERPRISE_HSOC_FREE_TRIAL: enviro.isProd() ? 282199 : 390133,
  CORE_SEATS_PROFESSIONAL_HSOC: enviro.isProd() ? 282195 : 380335,
  CORE_SEATS_PROFESSIONAL_HSOC_FREE_TRIAL: enviro.isProd() ? 282198 : 390129,
  FRONT_OFFICE_SEATS_ENTERPRISE: enviro.isProd() ? 282197 : 380337,
  FRONT_OFFICE_SEATS_ENTERPRISE_FREE_TRIAL: enviro.isProd() ? 282201 : 390135,
  FRONT_OFFICE_SEATS_PROFESSIONAL: enviro.isProd() ? 282194 : 380334,
  FRONT_OFFICE_SEATS_PROFESSIONAL_FREE_TRIAL: enviro.isProd() ? 282200 : 390134,
  AEO_STANDALONE: enviro.isProd() ? 290097 : 392272
};
export const apiNameToTrialIds = {
  [Products.SALES_HUB_ENTERPRISE]: TrialIds.SALES_ENTERPRISE,
  [Products.MARKETING_HUB_ENTERPRISE]: TrialIds.MARKETING_ENTERPRISE,
  [Products.SERVICE_HUB_ENTERPRISE]: TrialIds.SERVICE_ENTERPRISE,
  [Products.MARKETING_HUB_PROFESSIONAL]: TrialIds.MARKETING_PRO,
  [Products.CMS_HUB_PROFESSIONAL]: TrialIds.CMS_PROFESSIONAL,
  [Products.SALES_HUB_PROFESSIONAL]: TrialIds.SALES_PROFESSIONAL,
  [Products.SERVICE_HUB_PROFESSIONAL]: TrialIds.SERVICE_PROFESSIONAL,
  [Products.CMS_HUB_ENTERPRISE]: TrialIds.CMS_ENTERPRISE,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: TrialIds.DATA_PROFESSIONAL,
  [Products.OPERATIONS_HUB_ENTERPRISE]: TrialIds.DATA_ENTERPRISE,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: TrialIds.MARKETING_PLUS_ENTERPRISE_BUNDLE,
  [Products.CRM_SUITE_STARTER_BUNDLE]: TrialIds.CRM_SUITE_STARTER_BUNDLE,
  [Products.COMMERCE_HUB_PROFESSIONAL]: TrialIds.COMMERCE_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: TrialIds.COMMERCE_ENTERPRISE,
  [Products.CORE_SEATS_ENTERPRISE_HSOC]: TrialIds.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.CORE_SEATS_PROFESSIONAL_HSOC]: TrialIds.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.FRONT_OFFICE_SEATS_ENTERPRISE]: TrialIds.FRONT_OFFICE_SEATS_ENTERPRISE,
  [Products.FRONT_OFFICE_SEATS_PROFESSIONAL]: TrialIds.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.AEO_STANDALONE]: TrialIds.AEO_STANDALONE
};
export const apiNameToTrialLengthInDays = {
  [Products.AEO_STANDALONE]: 28
};

// HSoC has introduced needing to use a productApiName for both a free and paid version
// This is an override on the paid versions - the component handles the logic to map to correct Id
export const freePortalApiNameToTrialIds = Object.assign({}, apiNameToTrialIds, {
  [Products.CORE_SEATS_ENTERPRISE_HSOC]: TrialIds.CORE_SEATS_ENTERPRISE_HSOC_FREE_TRIAL,
  [Products.CORE_SEATS_PROFESSIONAL_HSOC]: TrialIds.CORE_SEATS_PROFESSIONAL_HSOC_FREE_TRIAL,
  [Products.FRONT_OFFICE_SEATS_ENTERPRISE]: TrialIds.FRONT_OFFICE_SEATS_ENTERPRISE_FREE_TRIAL,
  [Products.FRONT_OFFICE_SEATS_PROFESSIONAL]: TrialIds.FRONT_OFFICE_SEATS_PROFESSIONAL_FREE_TRIAL
});
export const trialIdToApiName = Object.fromEntries(Object.entries(apiNameToTrialIds).flatMap(([apiName, trialId]) => trialId !== undefined ? [[trialId, apiName]] : []));
export const trialIdsWithTrialGuide = [TrialIds.MARKETING_PRO, TrialIds.SALES_PROFESSIONAL, TrialIds.SERVICE_PROFESSIONAL, TrialIds.OPERATIONS_PROFESSIONAL, TrialIds.DATA_PROFESSIONAL, TrialIds.CMS_PROFESSIONAL, TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE, TrialIds.COMMERCE_PROFESSIONAL];
export const DEFAULT_TRIAL_DAYS = 14;
export const DEFAULT_TRIAL_DATA_EXPIRATION_DAYS = 104;